
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.166 5h1.667V3.334H9.166V5zM10 10a7.188 7.188 0 01-3.021-.656 30.282 30.282 0 01-2.813-1.469V6.667c0-.458.164-.85.49-1.177.327-.326.72-.49 1.177-.49H7.5V2.5c0-.236.08-.434.24-.593a.81.81 0 01.593-.24h3.333c.237 0 .435.08.595.24.16.16.24.358.239.593V5h1.666c.459 0 .851.164 1.178.49.327.327.49.72.49 1.177v1.208a30.166 30.166 0 01-2.813 1.47A7.178 7.178 0 0110 10zm-4.167 8.334V17.5c-.458 0-.85-.163-1.176-.489a1.608 1.608 0 01-.49-1.177V9.75c.777.473 1.58.875 2.406 1.209.827.333 1.691.555 2.593.666v.875h1.667v-.875a10.256 10.256 0 002.594-.666 16.556 16.556 0 002.406-1.209v6.084c0 .458-.163.85-.489 1.177a1.6 1.6 0 01-1.178.49v.833H12.5V17.5h-5v.834H5.833z","fill":"currentColor"}})])
          )
        }
      }
    